import { render } from "./CoursPage.vue?vue&type=template&id=02a27aeb"
import script from "./CoursPage.vue?vue&type=script&lang=js"
export * from "./CoursPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__